import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, Link, Stack, Typography } from '@mui/material';
import React, { memo, useEffect, useRef, useState } from 'react';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import CustomFieldModal from '../../../../modals/tables/dashboards/rows/CustomFieldModal';
import useStyles from "../styles";

const CustomFieldCell: React.FC<{
    dashboard: Dashboard,
    fieldName: string,
 }> = ({ dashboard, fieldName }) => {
    const classes = useStyles();
    const [customFieldModalOpen, setCustomFieldModalOpen] = useState<boolean>(false);
    const [customFieldValues, setCustomFieldValues] = useState<string>('');
    const latestUpdateRef = useRef<HTMLElement>(null);

    useEffect(() => {
        setCustomFieldValues(dashboard?.customFields?.find(({ name }) => name === fieldName)?.value as string);
    }, [dashboard?.customFields, fieldName]);

    return (<>
        <Stack width="100%" ref={latestUpdateRef}>
            {(!!customFieldValues && !['N/A', 'None'].includes(customFieldValues)) ? (
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                    <Typography className={classes.url} sx={{ maxWidth: '20ch !important' }}>
                        {customFieldValues}
                    </Typography>
                    <Stack direction="row" alignItems="stretch" justifyContent="flex-end">
                        <IconButton disableRipple
                            onClick={() => setCustomFieldModalOpen(true)}
                            sx={{ padding: 'unset !important'}}>
                            <ExpandMoreIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                        </IconButton>
                    </Stack>
                </Stack>
            ) : (
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                    <Link fontFamily="Lato" fontSize="0.9rem" fontWeight={500}
                        color={`${theme.colors.neutral['500']} !important`}
                        underline='hover'
                        onClick={() => setCustomFieldModalOpen(true)}
                        sx={{ cursor: 'pointer' }}>
                        {'Add value...'}
                    </Link>
                </Stack>
            )}
        </Stack>
        {customFieldModalOpen && (
            <CustomFieldModal
                open={customFieldModalOpen}
                dashboard={dashboard}
                fieldName={fieldName}
                newValue={!customFieldValues || ['N/A', 'None'].includes(customFieldValues)}
                anchorElement={latestUpdateRef.current}
                onClose={() => setCustomFieldModalOpen(false)} />
        )}
    </>);
}

export default memo(CustomFieldCell);
